import { settings } from "../settings";
import { impersonationStatusEndpoint } from "./impersonationEndpoints";

const { auth0DomainApiV2 } = settings;

// Who the logged-in user is impersonating, or null when no one or when it can't be told (old host,
// or the request failed). The banner it feeds is informational, so a failure is logged and shown
// as nothing rather than an error alert.
export async function fetchImpersonatedEmail(getAccessTokenSilently) {
    const url = impersonationStatusEndpoint();
    if (!url) {
        return null;
    }

    try {
        const token = await getAccessTokenSilently({
            audience: auth0DomainApiV2,
            scope: 'write:app_metadata',
        });

        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'X-CLIENT-TYPE': 'Bespoke',
                'X-APP-LOCALE': 'en-GB',
            }
        });

        if (response.status !== 200) {
            console.error(`Impersonation status request failed with ${response.status}.`);
            return null;
        }

        const body = await response.json();
        return body?.impersonatedEmail || null;
    } catch (e) {
        console.error(e);
        return null;
    }
}
